import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { ParameterType } from "@/types/parameterTypes";
import { useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { CollapseButton } from "../buttons/CollapseButton";
import { ParameterItemRun } from "./ParameterItemRun";

export function ProcedureParameterRun(props: {id: string, parameterType: ParameterType}) {
  const { id, parameterType } = props;
  const parameters = useParameterStore(useShallow((state) => state.parametersForSubjectAndType(id, parameterType)));

  const [showParameters, setShowParameters] = useState(false);

  if (parameters.length === 0) {
    return null;
  }

  return (
    <div className='card mt-4'>
      { !showParameters && parameters.map(parameter => <div id={parameter.id} key={parameter.id} />) }
      <div className='card-header d-flex align-items-center gap-2 py-0'>
        <div className='d-flex align-items-center gap-2'>
          <CollapseButton showElement={showParameters} setShowElement={setShowParameters} title={I18n.get('typeParameters', { type: I18n.get(parameterType) })}/>
          {I18n.get('typeParameters', { type: I18n.get(parameterType) })}
        </div>
      </div>
      { showParameters && <div className='card-body d-flex flex-column gap-2'>
        { parameters.map((parameter, index) =>
          <div key={parameter.id}>
            <ParameterItemRun parameter={parameter} key={parameter.id}/>
            {index < parameters.length - 1 && <hr />}
          </div>
        )}
      </div> }
    </div>
  );
}
